import React, { useContext, useEffect, useRef } from 'react';
import tw from 'twin.macro';
import { useInView } from '../common/hooks';
import { Button } from '../button';
import { AppContext, PreferenceContext } from '../context';

const LoadMoreItemsButton = ({ page }) => {
  const loadRef = useRef(null);
  const [ref, isInView] = useInView(loadRef, { threshold: 0.5 });

  const {
    listPages,
    listPages: { activeList, pageNums },
    setListPages,
  } = useContext(AppContext);

  const pageNumList = pageNums[activeList];

  const addPageNum = () =>
    setListPages({
      ...listPages,
      pageNums: {
        ...listPages.pageNums,
        [activeList]: [
          ...listPages.pageNums[activeList],
          listPages.pageNums[activeList].length - 1 + 1,
        ],
      },
    });

  useEffect(() => {
    if (isInView) {
      addPageNum();
    }
  }, [isInView]);

  return (
    <>
      {pageNumList &&
        (pageNumList.length === 0 || pageNumList[pageNumList.length - 1] === page) && (
          <div tw='w-full flex justify-center mb-4' ref={ref} onClick={() => addPageNum()}>
            <Button label='klik voor meer items' tw='w-max' ghost />
          </div>
        )}
    </>
  );
};

export const ItemsGrid = ({ children, noGrid, page = 0, hideAds, hideLoadMore = false }) => {
  const {
    preference: { landscape },
  } = useContext(PreferenceContext);

  return (
    <>
      <div
        css={[
          tw`gap-6 mb-6 sm:mb-0`,
          noGrid && tw`flex flex-col text-light`,
          !noGrid && tw`grid`,
          !landscape && !noGrid && tw`grid-cols-1 sm:grid-cols-2 2xl:grid-cols-3`,
          landscape && !noGrid && tw`flex-col sm:grid sm:grid-cols-2 xl:grid-cols-3`,
        ]}
      >
        {children}
      </div>
      {!noGrid && !hideLoadMore && <LoadMoreItemsButton page={page} />}
    </>
  );
};
